/** Shared menu dependencies: labels are business-facing, codes stay inside the system. */
export const adminMenuPermissions = {
    'ADM-L01': ['ad_landing.manage'],
    'ADM-L02': ['ad_landing.view'],
    'ADM-L03': ['ad_landing.view'],
    'ADM-A02': ['order.view', 'city.view', 'ops.monitor.view'],
    'ADM-A03': ['payment.view'],
    'ADM-A04': ['order.view'],
    'ADM-A05': ['order.view', 'product.view', 'member.view'],
    'ADM-A06': ['ops.monitor.view'],
    'ADM-A08': ['system.security.view'],
    'ADM-B01': ['city.view'],
    'ADM-B02': ['city.view'],
    'ADM-B03': ['city.view'],
    'ADM-B04': ['app.view'],
    'ADM-B05': ['app.view'],
    'ADM-B06': ['app.view'],
    'ADM-B07': ['app.view'],
    'ADM-B08': ['app.view'],
    'ADM-B09': ['app.view'],
    'ADM-B10': ['app.manage'],
    'ADM-B11': ['app.view'],
    'ADM-C01': ['product.view'],
    'ADM-C02': ['product.view'],
    'ADM-C03': ['product.view'],
    'ADM-C04': ['product.view'],
    'ADM-C05': ['product.view'],
    'ADM-C06': ['product.view'],
    'ADM-C07': ['product.view'],
    'ADM-C08': ['product.view'],
    'ADM-C09': ['product.view'],
    'ADM-C10': ['product.view'],
    'ADM-D01': ['cms.view'],
    'ADM-D02': ['cms.view'],
    'ADM-D03': ['cms.view'],
    'ADM-D04': ['cms.view'],
    'ADM-D05': ['cms.view'],
    'ADM-D06': ['cms.view'],
    'ADM-D07': ['cms.view'],
    'ADM-D08': ['cms.view'],
    'ADM-D09': ['cms.view'],
    'ADM-D10': ['cms.view'],
    'ADM-E01': ['order.view'],
    'ADM-E02': ['order.view'],
    'ADM-E03': ['order.view'],
    'ADM-E04': ['order.view'],
    'ADM-E05': ['order.view'],
    'ADM-E06': ['order.view'],
    'ADM-E07': ['order.communication.view'],
    'ADM-E08': ['refund.process'],
    'ADM-E09': ['after_sales.view'],
    'ADM-E10': ['order.export'],
    'ADM-F01': ['member.view'],
    'ADM-F02': ['member.view'],
    'ADM-F03': ['member.events.view'],
    'ADM-F04': ['member.tags.view'],
    'ADM-F05': ['member.analytics.view'],
    'ADM-F06': ['member.analytics.view'],
    'ADM-F07': ['member.analytics.view'],
    'ADM-F08': ['member.export'],
    'ADM-G01': ['payment.view'],
    'ADM-G02': ['payment.view'],
    'ADM-G03': ['payment.view'],
    'ADM-G04': ['payment.view'],
    'ADM-G05': ['payment.view'],
    'ADM-G06': ['payment.view'],
    'ADM-G07': ['payment.view'],
    'ADM-G08': ['payment.view'],
    'ADM-G09': ['refund.view'],
    'ADM-G10': ['payment.view'],
    'ADM-H01': ['marketing.coupon.view'],
    'ADM-H02': ['marketing.coupon.view'],
    'ADM-H03': ['marketing.rescue.view'],
    'ADM-H04': ['marketing.rescue.view'],
    'ADM-H05': ['channel.view'],
    'ADM-H06': ['channel.view'],
    'ADM-H07': ['channel.view'],
    'ADM-H08': ['channel.view'],
    'ADM-H09': ['commission.rule.view'],
    'ADM-H10': ['settlement.view'],
    'ADM-I01': ['message.view'],
    'ADM-I02': ['message.view'],
    'ADM-I03': ['message.view'],
    'ADM-I04': ['finance.view'],
    'ADM-I05': ['finance.view'],
    'ADM-I06': ['settlement.view'],
    'ADM-I07': ['report.view'],
    'ADM-I08': ['order.export', 'member.export', 'finance.export', 'report.export'],
    'ADM-J01': ['system.security.view'],
    'ADM-J02': ['system.security.view'],
    'ADM-J03': ['system.security.view'],
    'ADM-J04': ['system.security.view'],
    'ADM-J05': ['system.security.view'],
    'ADM-J06': ['system.security.view'],
    'ADM-J07': ['system.security.view'],
    'ADM-J08': ['release.view'],
    'ADM-J09': ['release.view'],
    'ADM-J10': ['ops.monitor.view'],
    'ADM-J11': ['system.security.view'],
};
export function visibleAdminMenuIds(permissionCodes) {
    const granted = new Set(permissionCodes);
    return [
        'ADM-A07',
        'ADM-A09',
        ...Object.entries(adminMenuPermissions)
            .filter(([, permissions]) => permissions.some((permission) => granted.has(permission)))
            .map(([id]) => id),
    ];
}
//# sourceMappingURL=admin-menu-access.js.map